import React, { useState, useEffect, useRef } from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import { Radio, Button, ContentsLayout, ContentsHeader, Select, Input } from 'src/components';
import { Scrollbars } from 'react-custom-scrollbars';
import Cookies from 'universal-cookie'
import { useCookies } from 'react-cookie';
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import ja from "date-fns/locale/ja";
import axios from 'axios';
import styles from './Chart.module.scss';
import { Bar ,Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip as Tooltip_ch,
  Legend as Legend_ch,
} from "chart.js";
import 'chart.js/auto';
import { Oval } from 'react-loader-spinner'
import { vermin_category } from 'src/utils/choises';

export type FormValues = {
  ecology_vermins: string[];
  /*start_date: string;
  end_date: string;*/
  start_date: Date | null;
  end_date: Date | null;
  lavel:string;
  type:string;
  id: string[] | undefined;
  category: string;
  all: string;
  displayability: string[];
};

/**
 * results:実データの集合
 * lavels:X軸ラベルの集合
 * client:法人名
 */
export type APIDate = {
  results : number[][] | string | [];
  lavels : [];
  client : string;
};

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip_ch,
  Legend_ch
);
//初期表示の判定
let first = false;
//日付の表示タイプの判定
let dayType = 0;
//今年の年を取得
const now_year = dayjs().year()
const firstEndDay = new Date((now_year+1)+"/03/31");
const firstStartDay = new Date((now_year)+"/04/01");
let sd_c = true;
let ed_c = true;
let dataType = 0;

/**
 * グラフ作成用関数
 * @param data
 * @returns 
 */
function VerminChart(data:any) {
  if (data.api === undefined) {return(<div></div>)};
  const vermin_type = Object.keys(vermin_category).length;
  let label2 = [];
  let chartData = [];
  const stack_number = Number(data.stack);
  let colorBalet = [];
  let change_key = 0;
  let GraphData = {
    labels: ['No_Date'],
    datasets: [{
      label: 'No_Date',
      data: [0],
      backgroundColor: ['#000000'],
      borderColor: ['#000000'],
      //borderRadius:5,
    }],
  };
  if((stack_number%100) === 2 && data.lavelKind === '7'){
    const year = Math.floor(data.api.lavels.length/12);
    const colorPatern = Math.floor(year/4) + 1;
    let xLavel = ''
    let rgb = '';
    let key = 0;
    for (var i = 0; i < colorPatern; i++){
      let cheng_color = Math.floor((255*(colorPatern - i))/colorPatern)
      colorBalet[colorBalet.length] = cheng_color+',0,0'
      colorBalet[colorBalet.length] = '0,'+cheng_color+',0'
      colorBalet[colorBalet.length] = '0,0,'+cheng_color
      /*colorBalet[colorBalet.length] = cheng_color+','+cheng_color+',0'*/
      colorBalet[colorBalet.length] = cheng_color+',0,'+cheng_color
      /*colorBalet[colorBalet.length] = '0,'+cheng_color+','+cheng_color*/
    }
    if (year >= 0) {
      GraphData.labels = ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
      for (var j = 0; j < year; j++ ) {
        rgb = 'rgb('+colorBalet[j]+')';
        xLavel = data.api.lavels[j*12].split('年')[0]+'年';
        GraphData.datasets[j]={label:xLavel,data:[0,0,0,0,0,0,0,0,0,0,0,0],backgroundColor:[rgb],borderColor:[rgb],}
        for (var k = 1; k <= vermin_type; k++) {
          if (data.addV.includes(String(k))){
            for (var i=0;i<12;i++){
              key = j * 12 + i;
              GraphData.datasets[j].data[i] += data.api.results[k][key];
            }
          }
        }
      }
    }
  } else if((stack_number%100) === 3 && data.lavelKind === "1"){
    chartData = JSON.parse(JSON.stringify(data.api.results));
    for (var i=3;i<12;i++){
      label2[label2.length] = data.api.lavels[i];
      for (var k = 1; k <= vermin_type; k++) {
        chartData[k][change_key] = data.api.results[k][i];
      }
      change_key++;
    }
    for (var i=0;i<3;i++){
      label2[label2.length] = data.api.lavels[i];
      for (var k = 1; k <= vermin_type; k++) {
        chartData[k][change_key] = data.api.results[k][i];
      }
      change_key++;
    }
  } else {
    label2 = data.api.lavels;
    chartData = JSON.parse(JSON.stringify(data.api.results));
  }
  if ((stack_number%100) !== 2 || data.lavelKind !== "7") {
    change_key = 0;
    colorBalet = ['rgb(20,163,78,1)','rgb(86,63,218,1)','rgb(218,141,36,1)','rgb(201,65,54,1)','rgb(242,203,70,1)','rgb(88,88,88,1)','rgb(200,200,200,1)'];
    GraphData.labels = label2;
    // console.log('check');
    for (var i = 1; i <= vermin_type; i++) {
      if (data.addV.includes(String(i))){
        GraphData.datasets[change_key]={label:vermin_category[i],data:chartData[i],backgroundColor:[colorBalet[i-1]],borderColor:[colorBalet[i-1]],}
        change_key++;
      }
    }
  }


  //グラフを重ねるか選択
  let stack = true;
  if(stack_number === 1 || ((stack_number%100) === 2 && data.lavelKind === "7") || stack_number > 100){
    stack = false;
  }

  //表示最大値最小値の設定
  let max = -1000;
  let min = 0;
  let max_min = 0
  if(GraphData.datasets[0].data !== undefined){
    max = GraphData.datasets[0].data[0];
    for (let j = 0; j < GraphData.datasets[0].data.length; j++) {
      if(stack) {
        max_min = 0
        for (let i = 0; i < GraphData.datasets.length; i++) {
          max_min += GraphData.datasets[i].data[j];
        }
        if(max < max_min) { max = max_min;}
      } else {
        for (let i = 0; i < GraphData.datasets.length; i++) {
          if(max < GraphData.datasets[i].data[j]) { max = GraphData.datasets[i].data[j];}
        }
      }
    }
  }
  if(data.min.length !== 0){ min = Number(data.min); }
  if(data.max.length !== 0){ max = Number(data.max); }
  if(max < min) {
    max_min = min;
    min = max;
    max = max_min;
  }

  //グラフのタイトル設定
  let category = "害獣";
  if (data.category === "damage") { category = "被害"; }
  const sub_title = data.api.client + "("+GraphData.labels[0]+"～"+GraphData.labels[GraphData.labels.length-1]+")";
  const title = category+"情報グラフ【"+sub_title+"】";
  //Y軸のタイトル設定
  let y_title = "頭数";
  if (data.dataKind === "1") { y_title = "登録件数"; }

  //グラフのオプション設定
  var options = {};
  if(stack_number < 100){
   options = {
      plugins: {
        title: {
          display: true,
          fontSize: 18,
          text:title,
        },
      },
      responsive: true,
      interaction: {
        mode: "index" as const,
        intersect: false,
      },
      scales: {
        x: {
          stacked: stack, 
        },
        y: {
          stacked: stack,
          min: Math.floor(min),
          max: Math.floor(max),
          stepSize: 1,
          title:{
            display: true,
            text: y_title,
          }
        },
      },
      maintainAspectRatio: false
    };
  } else {
    options = {
      plugins: {
        legend: {
          position: 'top' as const,
        },
        title: {
          display: true,
          fontSize: 18,
          text:title,
        },
      },
      scales: {
        y: {
          min: Math.floor(min),
          max: Math.floor(max),
          stepSize: 1,
          title:{
            display: true,
            text: y_title
          }
        },
      },
    };
  }
  //表示幅設定
  let singlX = 60;
  if (stack_number === 2 && data.lavelKind === "7") {
    singlX = 30;
  } else if(stack_number > 100) {
    singlX = 1;
  }
  const barWidth = String( GraphData.labels.length * singlX )+"px";
  if (Number(data.stack) < 100){
    return (
      <div style={{height:"95%",width:barWidth,minWidth:"95%"}}>
        <Bar options={options} data={GraphData} style={{width:"100%"}}/>
      </div>
    )
  }else{
    return (
      <div style={{height:"95%",width:barWidth,minWidth:"95%"}}>
        <Line options={options} data={GraphData} style={{width:"100%"}}/>
      </div>
    )
  }
}

/**
 * Chart コンポーネント
 * テナント情報
 * @returns React.ReactNode
 */
const Chart: React.FC = () => {

  // APIのデータ取得用
  const [apiData, setapiData] = useState<APIDate>();
  // ラベル種別情報保持用
  const [lavelKind, setlavelKind] = useState("1");
  // データ種別の情報保持用
  const [categoryName, setCate] = useState("vermin");
  // データ種別の情報保持用
  const [dataKind, setdataKind] = useState("0");

  /**
   * 表示を管理するカスタムフック
   * stack : 縦積みか横済みか
   * limit : データの表示上限
   * addVermin:合算害獣情報の情報保持用(積み上げ年度限定)
   */
    const { watch: watch_f, register: register_f } = useForm({
      defaultValues: {
        stack: '0',
        max_limit: [],
        min_limit: [],
        addVermin: ['1','2','3','4','5','6','7'],
      },
    });

  /**
   * 削除Cookie用
   */
    const cookies = new Cookies();

  /**
   * cookie
   */
    const [cookie] = useCookies(["verminData"]);
  
  /**
　 * API通信中判定フラグ
   */
  const [loading, setLoading] = useState(false);

  /**
   * 多重検索を抑制する検索処理を管理する変数設定
   */
  const submitProcessing = useRef(false);

  /**
   * フォームを管理するカスタムフック
   * register を適用したフィールドの値を handleSubmit で取得できる
   * See https://react-hook-form.com/api/useform
   * @example
   * <Form onSubmit={handleSubmit(submit)}>
   *   <input {...register('field_name')} />
   *   ...
   * </Form>
   */
  const { handleSubmit, register, watch, setValue, resetField, control, reset, formState: { errors } } = useForm<FormValues>({
    defaultValues: {
      category:"vermin",
      ecology_vermins: ['1','2','3','4','5','9','10'],
      lavel:"1",
      type:"0",
      id: [],
      all: '1',
    }
  });

    /**
   * submitイベントのコールバック関数
   * @example
   * handleSubmit(search)
   */
    const search: SubmitHandler<FormValues> = async (data) => {
      if(submitProcessing.current) return; // 送信処理中かを判定する（trueなら抜ける）
      submitProcessing.current = true; // 送信処理中フラグを設定
      console.log("rushTest")
      //Loading表示
      setLoading(true);
      //バックエンドに置くデータ取得
      const lavel = data.lavel;
      const type = data.type;
      let start_date = "";
      let end_date = "";
      if (lavel === "1") {
        start_date = data.start_date !== null ? dayjs(data.start_date).format("YYYY/MM/")+"01" : "";
        end_date = data.end_date !== null ? dayjs(data.end_date).endOf("month").format("YYYY/MM/DD") : "";
      } else if (lavel === "2" || lavel === "5" || lavel === "7") {
        start_date =  data.start_date !== null ? dayjs(data.start_date).format("YYYY/")+"01/01" : "";
        end_date = data.end_date !== null ? dayjs(data.end_date).format("YYYY/")+"12/31" : "";
      } else if (lavel === "3") {  
        const start_test = data.start_date !== null;
        const end_test = data.end_date !== null;
        let alertMessage = "";
        if (!start_test) {
          alertMessage += "取得開始日："
          if (end_test) {
            start_date =  dayjs(data.end_date).subtract(30,'day').format("YYYY/MM/DD"); 
          } else {
            start_date =  dayjs().subtract(6,'day').format("YYYY/MM/DD");
          }
          alertMessage += start_date + " "
        } else {
          start_date = dayjs(data.start_date).format("YYYY/MM/DD");
        }
        if (!end_test) {
          alertMessage += "取得終了日："
          if (start_test) {
            end_date =  dayjs(data.start_date).add(30,'day').format("YYYY/MM/DD");
          } else {
            end_date = dayjs().format("YYYY/MM/DD");
          }
          alertMessage += end_date + " "
        } else {
          end_date = dayjs(data.end_date).format("YYYY/MM/DD");
          if(dayjs(data.end_date).diff(dayjs(data.start_date), 'day') > 30) {
            end_date = dayjs(data.start_date).add(30,'day').format("YYYY/MM/DD");
            alertMessage  = "期間が32日以上の為、取得開始日："+start_date+" 取得終了日："+end_date+" ";
          }
        }
        if (alertMessage.length > 0) {
          alertMessage += "と設定し情報を取得します。"
          alert(alertMessage);
        }
      } else {
        start_date =  data.start_date !== null ? dayjs(data.start_date).format("YYYY/MM/DD") : "";
        end_date = data.end_date !== null ? dayjs(data.end_date).format("YYYY/MM/DD") : "";
      }
      let ecology = data.ecology_vermins;
      if (ecology.includes("5")  && watch('category') === "vermin"){
        ecology.push("6","7","8");
      }
      await axios.get(`${process.env.REACT_APP_DEV_API_URL}/chart_data/${watch('category')}`,
        {
          params: {
            start_date,
            end_date,
            ecology,
            lavel,
            type,
          }, headers: { Authorization: `Bearer ${cookie?.verminData?.api_token}` }
        }).then((data) => {
          /*get_data.features = data.data.results;*/
          setCate(watch('category'));
          setlavelKind(lavel);
          setdataKind(type);
          setapiData(data.data);
          first = true;
        }).catch(async err => {
          //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
          console.log(err);
          if (err?.response?.data?.message === "Unauthenticated.") {
            await cookies.remove('verminData');
            await window.location.replace('/');
          }
          console.log("Error_Finish");
        }).finally(() => {
          submitProcessing.current = false; // 送信処理中フラグを下げる
          //通信完了後Loading非表示
          setLoading(false)
        })
    };
  
  /**
   * GoogleAnalytics用トラッキング
   */
  useEffect(() => {
    window.gtag !== undefined && window.gtag('config', `${process.env.REACT_APP_DEV_TRACKING_ID}`, { page_path: window.location.pathname });
  }, []);

  /**
   * 条件に沿った出力データを作成
   */
    useEffect(() => {
      window.gtag !== undefined && window.gtag('config', `${process.env.REACT_APP_DEV_TRACKING_ID}`, { page_path: window.location.pathname });
    }, []);

  /**
  * 期間選択作成用関数
  * @param start_flg
  * @returns 
  */
  const GetDate = ({ start_flg }:{start_flg:String}) => {
    let dateName2 = "end_date_2";
    let text = "取得終了"
    const start_check = start_flg === "true"
    if (start_check) {
      dateName2 = "start_date_2";
      text = "取得開始"
    }
    if (watch('lavel') === "1"){
      if (dayType !== 0) {
        setValue('start_date',null);
        setValue('end_date',null);
        dayType = 0;
      }
      text = text + "月";
      if(sd_c || ed_c){
        if (start_check) {
          setValue('start_date',firstStartDay);
          sd_c = false;
        } else {
          setValue('end_date',firstEndDay);
          ed_c = false;
        }
      }
      return(
        /*<Controller control={control} 
          name={start_flg === "true" ? 'start_date' : 'end_date'} render={({ field: { onChange, value } }) => (
            <DatePicker onChange={onChange} dateFormat="yyyy/MM" showMonthYearPicker  locale={ja} name={dateName2}
            className={`${styles.input} ${styles.inputSelect}`} placeholderText={text} selected={value ? value as unknown as Date : firstDay} />
        )} />*/
        <DatePicker onChange={(date) => setValue(start_check ? 'start_date' : 'end_date',date)} dateFormat="yyyy/MM" todayButton="今月" showMonthYearPicker  locale={ja}
        name={dateName2} className={`${styles.input} ${styles.inputSelect}`} placeholderText={text} selected={watch(start_check ? 'start_date' : 'end_date')} />
      )
    } else if (watch('lavel') === "2" || watch('lavel') === "5" || watch('lavel') === "7") {
      if (dayType !== 1) {
        setValue('start_date',null);
        setValue('end_date',null);
        dayType = 1;
      }
      text = text + "年";
      return (
        <DatePicker onChange={(date) => setValue(start_check ? 'start_date' : 'end_date',date)} dateFormat="yyyy" todayButton="今年" showYearPicker locale={ja}
        name={dateName2} className={`${styles.input} ${styles.inputSelect}`} placeholderText={text} selected={watch(start_flg === "true" ? 'start_date' : 'end_date')}/>
        )
      } else {
        if (dayType !== 2) {
          setValue('start_date',null);
          setValue('end_date',null);
          dayType = 2;
        }
        text = text + "日";
        return(
          <DatePicker onChange={(date) => setValue(start_check ? 'start_date' : 'end_date',date)} dateFormat="yyyy/MM/dd"
            todayButton="今日" locale={ja} name={dateName2} showMonthDropdown={true} showYearDropdown={true}//230419追加
            className={`${styles.input} ${styles.inputSelect}`} placeholderText={text} selected={watch(start_flg === "true" ? 'start_date' : 'end_date')}/>
        )
      }
   };

  /**
  * 期間選択作成用関数
  * @param start_flg
  * @returns 
  */
  const KindDate = () => {
    if (watch('category') === "vermin"){
      if (dataType !== 0){
        setValue('ecology_vermins',['1','2','3','4','5','9','10']);
        dataType = 0;
      }
      return(
        <section className={`${styles.rowField} ${styles.rowChartRadio}`}>
          <span  className={styles.labelText}>状況種別</span>
            <Radio type="checkbox" value="1" className={styles.radioText} {...register('ecology_vermins')} >
              捕獲
            </Radio>
            <Radio type="checkbox" value="2" className={styles.radioText} {...register('ecology_vermins')}>
              観察
            </Radio>
            <Radio type="checkbox" value="3" className={styles.radioText} {...register('ecology_vermins')}>
              狩猟
            </Radio>
            <Radio type="checkbox" value="4" className={styles.radioText} {...register('ecology_vermins')}>
              目撃
            </Radio>
            <Radio type="checkbox" value="5" className={styles.radioText} {...register('ecology_vermins')}>
              痕跡
            </Radio>
            <Radio type="checkbox" value="10" className={styles.radioText} {...register('ecology_vermins')}>
              テレメトリー
            </Radio>
            <Radio type="checkbox" value="9" className={styles.radioText} {...register('ecology_vermins')}>
              錯誤捕獲
            </Radio>
        </section>
      )
    } else {
      if (dataType !== 1){
        setValue('ecology_vermins',['2']);
        dataType = 1;
      }
      setValue('type','1')
      return(
        <section className={`${styles.rowField} ${styles.rowChartRadio}`}>
            <span  className={styles.labelText}>被害種別</span>
            <Radio type="checkbox" value="2" className={styles.radioText} {...register('ecology_vermins')} >
              人的被害
            </Radio>
            <Radio type="checkbox" value="4" className={styles.radioText} {...register('ecology_vermins')}>
              農作物被害
            </Radio>
            <Radio type="checkbox" value="5" className={styles.radioText} {...register('ecology_vermins')}>
              生活環境被害
            </Radio>
            <Radio type="checkbox" value="1" className={styles.radioText} {...register('ecology_vermins')}>
              柵被害
            </Radio>
        </section>
      )
    }
      
   };   

  return (
    <Scrollbars>
    <form onSubmit={handleSubmit(search)} className={styles.form}>
    {loading &&
      <div className={styles.modalWrapper}>
        <div className={styles.modalOverlay}>
          <Oval
            ariaLabel="loading-indicator"
            height={75}
            width={75}
            strokeWidthSecondary={1}
            color="#3a6468"
            secondaryColor="white"
          />
        </div>
      </div>
    }
    <ContentsLayout>
      {/*<ContentsHeader title="グラフ表示">
      </ContentsHeader>*/}
      <div className={styles.row}>
        <section className={`${styles.rowField} ${styles.rowChartInput}`}>
          <span  className={styles.ChartTitle}>グラフ表示</span>
        </section>
        <section className={styles.rowField} style={{marginBottom:"1px"}}>
          <span  className={styles.labelText}>集計単位</span>
            <Select className={styles.rubyMargin} disabled={Number(watch_f('stack'))%100 === 2 || watch_f('stack') === '3'} {...register('lavel')} >
              <option value="1">月(累計)</option>
              <option value="7">月(年別)</option>
              <option value="2">年</option>
              <option value="3">日(最大31日分)</option>
              <option value="4">時間</option>
              {/*<option value="5">季節毎集計</option>*/}
              <option value="6">時間帯</option>
            </Select>
        </section>
        <section className={`${styles.rowField} ${styles.rowChartInput}`} style={{marginBottom:"1px"}}>
          <label>
            <span className={styles.labelText}>取得期間</span>
          </label>
          <ruby>
            <GetDate start_flg="true" />
            <span className={styles.range}>
              ~
            </span>
          <GetDate start_flg="false" />
          <rt className={styles.rubystyle}>指定期間の累計を表示</rt>
          </ruby>
        </section>
        <section className={`${styles.rowField} ${styles.rowChartInput}`} style={{marginBottom:"1px"}}>
          <span className={styles.labelText}>データ種類</span>
          <Select className={`${styles.minwidth0} ${styles.rubyMargin}`} {...register('category')}>
            <option value="vermin">害獣</option>
            <option value="damage">被害</option>
          </Select>
        </section>
        <KindDate />
        <section className={`${styles.rowField} ${styles.rowChartInput}`} style={{marginBottom:"1px"}}>
          <span className={styles.labelText}>カウント種類</span>
          <ruby>
          <Select className={`${styles.minwidth0} ${styles.rubyMargin}`} {...register('type')}>
            <option value="0" style={watch('category') === 'vermin' ? {display: ''} : {display: 'none'}}>頭数</option>
            <option value="1">登録件数</option>
          </Select>
          <rt className={styles.rubystyle}>&nbsp;</rt>
          </ruby>
        </section>
        <section className={`${styles.rowField}`}>
          <Button className={`${styles.buttonMargin} ${styles.rubyMarginButton}`} type="submit">データ取得/グラフ表示</Button>
        </section>
      </div>
      <div className={styles.row}>
        <section className={`${styles.rowField} ${styles.rowChartRadio}`}>
            {/*<span className={styles.labelText}>グラフの縦棒</span>*/}
            <span className={styles.labelText}>棒グラフ</span>
            <Radio
              value="0"
              className={styles.radioText}
              {...register_f('stack')}>
              積み上げ
            </Radio>
            <Radio
              value="2"
              className={`${styles.radioText} ${watch('lavel') !== '7' ? styles.displayNone : ''}`}
              disabled={watch('lavel')!=='7'}
              {...register_f('stack')}
            >
              積み上げ年集合
            </Radio>
            <Radio
              value="3"
              className={`${styles.radioText} ${watch('lavel') !== '1' ? styles.displayNone : ''}`}
              disabled={watch('lavel')!=='1'}
              {...register_f('stack')}
            >
              積み上げ年度順
            </Radio>
            <Radio
              value="1"
              className={styles.radioText}
              {...register_f('stack')}
            >
              害獣集合
            </Radio>
        </section>
        <section className={`${styles.rowField} ${styles.rowChartRadio}`}>
            {/*<span className={styles.labelText}>グラフの縦棒</span>*/}
            <span className={styles.labelText}>折れ線グラフ</span>
            <Radio
              value="102"
              className={`${styles.radioText} ${watch('lavel') !== '7' ? styles.displayNone : ''}`}
              {...register_f('stack')}>
              積み上げ年集合
            </Radio>
            <Radio
              value="101"
              className={styles.radioText}
              {...register_f('stack')}>
              害獣集合
            </Radio>
        </section>
        <section className={`${styles.rowField} ${styles.rowChartInput}`} style={{marginBottom:"1px"}}>
            <span className={styles.labelText}>表示下限</span>
            <Input
                type="number"
                placeholder="表示下限"
                className={`${styles.input} ${styles.rubyMargin}`}
                {...register_f("min_limit",{ pattern: /^[0-9]*$/ })}
              />
            <span className={styles.labelText} style={{marginLeft:"10px"}}>表示上限</span>
            <Input
                type="number"
                placeholder="表示上限"
                className={`${styles.input} ${styles.rubyMargin}`}
                {...register_f("max_limit",{ pattern: /^[0-9]*$/ })}
              />
        </section>
        <section className={`${styles.rowField} ${styles.rowChartRadio}`}>
          <span className={styles.labelText}>表示害獣</span>
          {Object.entries(vermin_category).map((value) => {
            return(
              <Radio type="checkbox" value={value[0]} className={styles.radioText} {...register_f('addVermin')} >
                {value[1]}
              </Radio>
              );
            })
          }
        </section>
      </div>
      <Scrollbars className={styles.bottomTable}>
        {(first) && 
          <VerminChart 
          api={apiData}
          stack={watch_f('stack')}  max={watch_f('max_limit')}  min={watch_f('min_limit')} addV={watch_f('addVermin')}
          lavelKind={lavelKind}  category={categoryName}  dataKind={dataKind}/>
        }
      </Scrollbars>
    </ContentsLayout>
    </form>
    </Scrollbars>
  );
};

export default Chart;